import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneCountryCode?: string;
  phone?: string;
  company?: string;
  jobTitle?: string;
  avatar?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = 'http://localhost:8081/api/users';
  private currentUserSubject = new BehaviorSubject<User>({
    id: '', firstName: '', lastName: '', email: ''
  });
  
  public currentUser = this.currentUserSubject.asObservable();
  
  constructor(private http: HttpClient) {}
  
  get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  
  updateCurrentUser(user: User): void {
    this.currentUserSubject.next(user);
  }
  
  getUserProfile(): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/profile`, { withCredentials: true }).pipe(
      tap(user => this.currentUserSubject.next(user))
    );
  }
  
  updateUserProfile(user: User): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/profile`, user, { withCredentials: true }).pipe(
      tap(updatedUser => this.currentUserSubject.next(updatedUser))
    );
  }
  
  changePassword(currentPassword: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/change-password`, { currentPassword, newPassword }, { withCredentials: true });
  }
  
  updateAvatar(avatarFile: File): Observable<{ avatarUrl: string }> {
    const formData = new FormData();
    formData.append('avatar', avatarFile);
    return this.http.post<{ avatarUrl: string }>(`${this.apiUrl}/avatar`, formData, { withCredentials: true }).pipe(
      tap(response => {
        const user = this.currentUserValue;
        user.avatar = response.avatarUrl;
        this.currentUserSubject.next(user);
      })
    );
  }
}